import React, { useState, useEffect } from 'react';
import {
    Box, Grid, Button, Typography
} from '@mui/material';
import { postData } from '../../ServerRequest';
import * as XLSX from 'xlsx';
import LoaderStyleOne from '../../components/LoaderStyleOne';

const UploadBulkImage = () => {
    const [productCode, setProductCode] = useState('');
    const [images, setImages] = useState({});
    const [excelName, setExcelName] = useState('productExcel');
    const [productCodeList, setProductCodeList] = useState([]);


    const [productDetails, setProductList] = useState({
        productName: '',
        description: '',
        price: ''
    });
    const [productsData, setProductsData] = useState([]);
    const [productStatus, setProductStatus] = useState('added');
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedTab, setSelectedTab] = useState(0);

    const [pagination, setPagination] = useState({ current_page: 1, per_page: 10, total: 0 });
    const [loading, setLoading] = useState(false);
    const [productCount, setProductCount] = useState(0);
    const [counts, setCounts] = useState({
        addedProductCount: 0,
        liveProductCount: 0,
        archivedProductCount: 0,
        deletedProductCount: 0,
    });



    useEffect(() => {
    }, []);

    const readExcelFile = (file) => {
        console.log(file);
        
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                // const productIds = jsonData.map((row) => row.product_id);

                // Assuming the product IDs are in the first column of the first sheet
                const productIds = jsonData.map((row) => row[Object.keys(row)[0]]); // Adjust this line based on your Excel structure
                setProductCodeList(productIds);
                resolve(productIds);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsArrayBuffer(file);
        });
    };


    const handleProductCodeChange = (event, newValue) => {
        setProductCode(newValue ? newValue.code : '');
    };

    const handleImageChange = (e) => {
        const { name, files } = e.target;
        setImages((prevImages) => ({
            ...prevImages,
            [name]: files[0],
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        console.log(productCodeList);
        
        const reqData = {
            product_ids: productCodeList
        };
        try {
            const response = await postData('/api/product/bulk-upload-fabric-image', reqData);
            if (response.data.code === '200') {

                alert("Images uploaded successfully");
                setLoading(false);
                window.location.reload();
            }
            else {
                alert("Error uploading images");
                setLoading(false);
                window.location.reload();
            }
        } catch (error) {
            alert("Error uploading images");
            setLoading(false);
            window.location.reload();
            console.error('Error uploading images:', error);
        }
    };

    if (loading) {
        return (
            <Box sx={{ width: '97.5%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
                <LoaderStyleOne />
            </Box>
        );
    }

    return (
        <Box sx={{ width: '95%', paddingLeft: 3, mb: 5 }}>
            <Grid container sx={{ flex: 1, height: '100%' }}>
                <Box sx={{ width: '100%', height: '100%' }}>
                    <Box sx={{ border: '2px solid #F4F3F6', p: 3, borderRadius: 0, background: '#f8f9fa' }}>
                        <Typography variant="body1" sx={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 16, mb: 8 }}>
                            Import Excel for Bulk Image Upload
                        </Typography>
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sx={{ mb: 3 }}>
                                    <Typography sx={{ fontSize: 15, fontWeight: 600, mb: 1 }}>Excel File:</Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, border: '1px solid #E0E0E0', borderRadius: 0, p: 2, background: '#FFF' }}>
                                        <input
                                            type="file"
                                            id={excelName}
                                            name={excelName}
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    readExcelFile(file)
                                                        .then(() => alert("Excel file processed successfully"))
                                                        .catch((error) => alert("Error processing Excel file: " + error.message));
                                                }
                                            }}
                                            style={{ marginBottom: '8px' }}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button 
                                        type="submit" 
                                        variant="outlined"
                                        sx={{
                                            backgroundColor: "#565E6D",
                                            border: "1px solid #565E6D",
                                            color: "#fff",
                                            "&:hover": { backgroundColor: "#546e7a" },
                                            borderRadius: "0px",
                                        }}>
                                        Upload
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                </Box>
            </Grid>
        </Box>
    );
};

export default UploadBulkImage;